import { render } from "./login-dialog.vue?vue&type=template&id=670ea81a&scoped=true"
import script from "./login-dialog.vue?vue&type=script&lang=js"
export * from "./login-dialog.vue?vue&type=script&lang=js"

import "./login-dialog.vue?vue&type=style&index=0&id=670ea81a&lang=scss&scoped=true"

import exportComponent from "D:\\Afwct\\emis2.0\\emis-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670ea81a"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardActions,QSeparator,QForm,QCardSection,QSelect,QBtn,QField});
